import React from 'react';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { useNavigate } from 'react-router-dom';
import { useI18n } from '@/i18n/I18nContext';

const NotFoundPage: React.FC = () => {
	const navigate = useNavigate();
	const { t } = useI18n();
	return (
		<Container sx={{ py: 10, textAlign: 'center' }}>
			<Stack spacing={2} alignItems="center">
				<Typography variant="h2" fontWeight={800}>{t.notFound.title}</Typography>
				<Typography color="text.secondary">{t.notFound.message}</Typography>
				<Button variant="contained" onClick={() => navigate('/')}>
					{t.notFound.backHome}
				</Button>
			</Stack>
		</Container>
	);
};

export default NotFoundPage;
